import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button } from 'semantic-ui-react';
import FilterGroupSection, { emptyFilterGroup, normalizeFilterGroup } from '../../../Commons/FilterGroupSection';

class RehiredEmployeeReportModal extends Component {

    constructor(props) {
        super(props);
        var defaultState = {
            filterGroup: emptyFilterGroup(),
        };

        const savedState = sessionStorage.getItem("RehiredEmployeeReportFilterState");
        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.state = { ...defaultState, ...parsed, filterGroup: normalizeFilterGroup(parsed.filterGroup) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
        };
        sessionStorage.setItem("RehiredEmployeeReportFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            includeDeleted: true,
            message: "from rehired employee modal",
            Search: "",
            startingIndex: 0,
            itemCount: 20
        };
    }

    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Rehired Employee Report Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                </Modal.Content>
                <Modal.Actions>
                    <Button basic content="Generate" onClick={this.props.onSave}></Button>
                    <Button basic content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default RehiredEmployeeReportModal;
